/* eslint import/order: 0 */

import DialogModal from 'components/modals/DialogModal/DialogModal'

import ServerErrorModal from './ServerErrorModal/ServerErrorModal'
import SomethingWentWrongModal from './SomethingWentWrongModal/SomethingWentWrongModal'
import ChangesSaveSuccessModal from './ChangesSaveSuccessModal/ChangesSaveSuccessModal'
import CardUpdateSuccessModal from './CardUpdateSuccessModal/CardUpdateSuccessModal'
import ProductDetailsModal from './ProductDetailsModal/ProductDetailsModal'
import SameFragranceErrorModal from './SameFragranceErrorModal/SameFragranceErrorModal'
import RedeemConfirmationModal from './RedeemConfirmationModal/RedeemConfirmationModal'
import RedeemSuccessModal from './RedeemSuccessModal/RedeemSuccessModal'
import LoginRequiredModal from './LoginRequiredModal/LoginRequiredModal'
import QuizStartModal from './QuizStartModal/QuizStartModal'
import ThankYouQueueModal from './ThankYouQueueModal/ThankYouQueueModal'
import PickDateModal from './PickDateModal/PickDateModal'
import MembershipInfoModal from './MembershipInfoModal/MembershipInfoModal'
import FirstTimeVisitModal from './FirstTimeVisitModal/FirstTimeVisitModal'

// Queue
import HowQueueWorksModal from './HowQueueWorksModal/HowQueueWorksModal'
import QueueTutorialModal from './QueueTutorialModal/QueueTutorialModal'
import EmptyQueueRecommendationsModal from './EmptyQueueRecommendationsModal/EmptyQueueRecommendationsModal'

// New products
import MakeupModal from './newProducts/MakeupModal/MakeupModal'
import SkincareModal from './newProducts/SkincareModal/SkincareModal'
import SkincareWellnessModal from './newProducts/SkincareWellnessModal/SkincareWellnessModal'
import LipBalmsModal from './newProducts/LipBalmsModal/LipBalmsModal'

// Skip a Month
import SkipAMonthModal from './SkipAMonthModal/SkipAMonthModal'
import SkipAMonthSuccessModal from './SkipAMonthSuccessModal/SkipAMonthSuccessModal'

// Cancel skip
import UnskipSuccessModal from './UnskipSuccessModal/UnskipSuccessModal'

// Change Frequency
import ChangeFrequencyModal from './ChangeFrequencyModal/ChangeFrequencyModal'
import FrequencyChangeSuccessModal from './FrequencyChangeSuccessModal/FrequencyChangeSuccessModal'

// Update PayPal
import ErrorPayPalModal from './ErrorPayPalModal/ErrorPayPalModal'
import AlreadyUpdatedToPayPalModal from './AlreadyUpdatedToPayPalModal/AlreadyUpdatedToPayPalModal'

// Complete Subscription
import CompleteSubscriptionModal from './CompleteSubscriptionModal/CompleteSubscriptionModal'

// Upgrade Subscription
import OldUpgradeSubscriptionModal from './OldUpgradeSubscriptionModal/OldUpgradeSubscriptionModal'
import UpgradeSubscriptionModal from './UpgradeSubscriptionModal/UpgradeSubscriptionModal'
import QueueUpgradeModal from './QueueUpgradeModal/QueueUpgradeModal'

// Cancel Subscription
import CancelSubscriptionModal from './cancelSubscription/CancelSubscriptionModal/CancelSubscriptionModal'
import BeforeYouGoModal from './cancelSubscription/BeforeYouGoModal/BeforeYouGoModal'
import OneLastQuestionModal from './cancelSubscription/OneLastQuestionModal/OneLastQuestionModal'
import SubscriptionWasCancelledModal from './cancelSubscription/SubscriptionWasCancelledModal/SubscriptionWasCancelledModal'
import ProlongOfferModal from './cancelSubscription/ProlongOfferModal/ProlongOfferModal'
import ProlongThankYouModal from './cancelSubscription/ProlongThankYouModal/ProlongThankYouModal'
import PauseSubscriptionModal from './cancelSubscription/PauseSubscriptionModal/PauseSubscriptionModal'
import UnpauseRequiredModal from './cancelSubscription/UnpauseRequiredModal/UnpauseRequiredModal'
import UnsubscribeProductsModal from './cancelSubscription/UnsubscribeProductsModal/UnsubscribeProductsModal'
import RefundModal from './cancelSubscription/RefundModal/RefundModal'
import RefundOnTheDayOfCharge from './cancelSubscription/RefundOnTheDayOfCharge/RefundOnTheDayOfCharge'
import ShippingAndBillingIssuesModal from './cancelSubscription/ShippingAndBillingIssuesModal/ShippingAndBillingIssuesModal'
import OfferTest25offModal from 'components/_new/modals/cancelSubscription/OfferTest25offModal/OfferTest25offModal'
import OfferTest25offSuccessModal from 'components/_new/modals/cancelSubscription/OfferTest25offSuccessModal/OfferTest25offSuccessModal'
import FeedbackModal from './cancelSubscription/FeedbackModal/FeedbackModal'
import FeedbackErrorModal from 'pages/CancelSubscriptionPage/FeedbackForm/FeedbackErrorModal/FeedbackErrorModal'

// Smart Search
import SubscriptionUndeliverableModal from './SubscriptionUndeliverableModal/SubscriptionUndeliverableModal'
import WeMissedYouModal from './WeMissedYouModal/WeMissedYouModal'
import TryTwoThreeFragrancesModal from './TryTwoThreeFragrancesModal/TryTwoThreeFragrancesModal'

// Prepaid Card
import PrepaidCardWithDiscountModal from './prepaidCard/PrepaidCardWithDiscountModal/PrepaidCardWithDiscountModal'
import PrepaidCardWithSubscriptionPlansModal from './prepaidCard/PrepaidCardWithSubscriptionPlansModal/PrepaidCardWithSubscriptionPlansModal'

// Resubscribe
import ResubscribeSuccessModal from './resubscribe/ResubscribeSuccessModal/ResubscribeSuccessModal'
import GetBackTogetherModal from './resubscribe/GetBackTogetherModal/GetBackTogetherModal'
import ResubscribeWithDiscountModal from './resubscribe/ResubscribeWithDiscountModal/ResubscribeWithDiscountModal'
import SuccessfullyResubscribedModal from './resubscribe/SuccessfullyResubscribedModal/SuccessfullyResubscribedModal'
import ReactivateSubscriptionModal from './resubscribe/ReactivateSubscriptionModal/ReactivateSubscriptionModal'

// GiftSets
import GiftSetQuickViewModal from './GiftsetQuickViewModal/GiftSetQuickViewModal'

// Gifts
import SetGiftDateModal from './gifts/SetGiftDateModal/SetGiftDateModal'
import ChooseGiftSizeModal from './gifts/ChooseGiftSizeModal/ChooseGiftSizeModal'
import ChooseGiftCardSkinModal from './gifts/ChooseGiftCardSkinModal/ChooseGiftCardSkinModal'
import ChooseGiftCardValueModal from './gifts/ChooseGiftCardValueModal/ChooseGiftCardValueModal'
import SetGiftRecipientInfoModal from './gifts/SetGiftRecipientInfoModal/SetGiftRecipientInfoModal'
import ChooseGiftCardDeliveryTypeModal from './gifts/ChooseGiftCardDeliveryTypeModal/ChooseGiftCardDeliveryTypeModal'
import GiftRedeemedModal from './gifts/GiftRedeemedModal/GiftRedeemedModal'

// Review
import ReviewItemListModal from './review/ReviewItemListModal/ReviewItemListModal'
import ReviewComposerModal from './review/ReviewComposerModal/ReviewComposerModal'
import ReviewEditModal from './review/ReviewEditModal/ReviewEditModal'
import ReviewTagsModal from './review/ReviewTagsModal/ReviewTagsModal'
import RecommendationsModal from './review/RecommendationsModal/RecommendationsModal'
import IncubatorReviewEditModal from './review/IncubatorReviewEditModal/IncubatorReviewEditModal'

// Pause Subscription

import UnpauseSubscriptionModal from './pauseSubscription/UnpauseSubscriptionModal/UnpauseSubscriptionModal'
import PauseSuccessModal from './pauseSubscription/PauseSuccessModal/PauseSuccessModal'
import UnpauseSuccessModal from './pauseSubscription/UnpauseSuccessModal/UnpauseSuccessModal'
import PauseOneMonthSuccessModal from './pauseSubscription/PauseOneMonthSuccessModal/PauseOneMonthSuccessModal'

// Invite
import ChooseFriendsToInviteModal from './ChooseFriendsToInviteModal/ChooseFriendsToInviteModal'

// Register
import FacebookRegisterModal from './FacebookRegisterModal/FacebookRegisterModal'
import RemindPasswordModal from './RemindPasswordModal/RemindPasswordModal'

// Password
import ShortPasswordModal from './ShortPasswordModal/ShortPasswordModal'

// Products
import RecommendationTagModal from './RecommendationTagModal/RecommendationTagModal'
import NoteRecommendationsModal from './NoteRecommendationsModal/NoteRecommendationsModal'

// Payment
import AddressValidationModal from './AddressValidationModal/AddressValidationModal'
import CustomAddressValidationModal from './CustomAddressValidationModal/CustomAddressValidationModal'
import ErrorCVVModal from './ErrorCVVModal/ErrorCVVModal'
import LeavePaymentModal from './LeavePaymentModal/LeavePaymentModal'

// Downgrade
import PreparingDowngradeModal from './PreparingDowngradeModal/PreparingDowngradeModal'
import AlreadyDowngradeModal from './AlreadyDowngradeModal/AlreadyDowngradeModal'

// Limited Edition Products
import NeedUpdateAddressModal from './limitedEditionProducts/NeedUpdateAddressModal/NeedUpdateAddressModal'
import NeedUpdateCardModal from './limitedEditionProducts/NeedUpdateCardModal/NeedUpdateCardModal'
import NeedChangeFrequencyModal from './limitedEditionProducts/NeedChangeFrequencyModal/NeedChangeFrequencyModal'
import NeedResubscribeModal from './limitedEditionProducts/NeedResubscribeModal/NeedResubscribeModal'
import NeedSubscribeModal from './limitedEditionProducts/NeedSubscribeModal/NeedSubscribeModal'
import NeedUnpauseModal from './limitedEditionProducts/NeedUnpauseModal/NeedUnpauseModal'
import NeedUnskipModal from './limitedEditionProducts/NeedUnskipModal/NeedUnskipModal'
import OutOfStockModal from './limitedEditionProducts/OutOfStockModal/OutOfStockModal'
import OutOfStockNotifyModal from './limitedEditionProducts/OutOfStockNotifyModal/OutOfStockNotifyModal'
import PutFirstInQueueModal from './limitedEditionProducts/PutFirstInQueueModal/PutFirstInQueueModal'

// Premium Products
import WelcomeBackModal from './premiumProducts/WelcomeBackModal/WelcomeBackModal'
import AddedProductModal from './premiumProducts/AddedProductModal/AddedProductModal'
import NeedCardUpdateModal from './premiumProducts/NeedCardUpdateModal/NeedCardUpdateModal'
import NeedPaymentDataModal from './premiumProducts/NeedPaymentDataModal/NeedPaymentDataModal'
import NeedSubscriptionModal from './premiumProducts/NeedSubscriptionModal/NeedSubscriptionModal'

// Pick Page
import PickProductsModal from './PickProductsModal/PickProductsModal'

// Add To Queue
import ProductAddedToQueueModal from './addToQueue/ProductAddedToQueueModal/ProductAddedToQueueModal'
import OfferModal from './addToQueue/OfferModal/OfferModal'

import SkincareProductDetailsModal from 'components/_new/modals/SkincareProductDetailsModal/SkincareProductDetailsModal'
import FlashSaleModal from 'components/_new/modals/FlashSaleModal/FlashSaleModal'

// Humble ------------------------------------------------------------------ /

import HumbleServerErrorModal from 'components/_new/modals/ServerErrorModal/ServerErrorModal'
import FeedbackSuccessModal from 'components/_new/modals/FeedbackSuccessModal/FeedbackSuccessModal'
import FlashSaleExpiredModal from 'pages/bundle/FlashSaleBundlePage/FlashSaleExpiredModal/FlashSaleExpiredModal'


export default {
  DialogModal,
  ServerErrorModal,
  SomethingWentWrongModal,
  ChangesSaveSuccessModal,
  CardUpdateSuccessModal,
  ProductDetailsModal,
  SameFragranceErrorModal,
  RedeemConfirmationModal,
  RedeemSuccessModal,
  QuizStartModal,
  PickDateModal,
  MembershipInfoModal,
  FirstTimeVisitModal,

  // Queue
  HowQueueWorksModal,
  QueueTutorialModal,
  EmptyQueueRecommendationsModal,

  // New Products
  MakeupModal,
  SkincareModal,
  SkincareWellnessModal,
  LipBalmsModal,

  // Skip a Month
  SkipAMonthModal,
  SkipAMonthSuccessModal,
  UnskipSuccessModal,

  // Change Frequency
  ChangeFrequencyModal,
  FrequencyChangeSuccessModal,

  // Update PayPal
  ErrorPayPalModal,
  AlreadyUpdatedToPayPalModal,

  // Complete Subscription
  CompleteSubscriptionModal,

  // Upgrade Subscription
  OldUpgradeSubscriptionModal,
  UpgradeSubscriptionModal,
  QueueUpgradeModal,

  // Cancel Subscription
  CancelSubscriptionModal,
  BeforeYouGoModal,
  OneLastQuestionModal,
  SubscriptionWasCancelledModal,
  ProlongOfferModal,
  ProlongThankYouModal,
  PauseSubscriptionModal,
  UnpauseSubscriptionModal,
  UnsubscribeProductsModal,
  RefundModal,
  RefundOnTheDayOfCharge,
  ShippingAndBillingIssuesModal,
  OfferTest25offModal,
  OfferTest25offSuccessModal,
  FeedbackModal,
  FeedbackErrorModal,

  // Smart Search
  SubscriptionUndeliverableModal,
  WeMissedYouModal,
  TryTwoThreeFragrancesModal,

  // Prepaid Card
  PrepaidCardWithDiscountModal,
  PrepaidCardWithSubscriptionPlansModal,

  // Resubscribe
  ResubscribeSuccessModal,
  GetBackTogetherModal,
  ResubscribeWithDiscountModal,
  SuccessfullyResubscribedModal,
  ReactivateSubscriptionModal,

  // GiftSet
  GiftSetQuickViewModal,

  // Gifts
  SetGiftDateModal,
  ChooseGiftSizeModal,
  ChooseGiftCardSkinModal,
  ChooseGiftCardValueModal,
  SetGiftRecipientInfoModal,
  ChooseGiftCardDeliveryTypeModal,
  GiftRedeemedModal,

  // Review
  ReviewItemListModal,
  ReviewComposerModal,
  ReviewEditModal,
  ReviewTagsModal,
  IncubatorReviewEditModal,
  LoginRequiredModal,
  RecommendationsModal,

  // Pause Subscription
  UnpauseRequiredModal,
  PauseSuccessModal,
  UnpauseSuccessModal,
  PauseOneMonthSuccessModal,

  // Invite
  ChooseFriendsToInviteModal,

  // Register
  FacebookRegisterModal,
  RemindPasswordModal,

  // Password
  ShortPasswordModal,

  // ThanYou
  ThankYouQueueModal,

  // Products
  RecommendationTagModal,
  NoteRecommendationsModal,

  // Payment
  AddressValidationModal,
  ErrorCVVModal,
  LeavePaymentModal,
  CustomAddressValidationModal,

  // Downgrade
  PreparingDowngradeModal,
  AlreadyDowngradeModal,

  // Limited Edition Products
  NeedUpdateAddressModal,
  NeedUpdateCardModal,
  NeedChangeFrequencyModal,
  NeedResubscribeModal,
  NeedSubscribeModal,
  NeedUnpauseModal,
  NeedUnskipModal,
  OutOfStockModal,
  OutOfStockNotifyModal,
  PutFirstInQueueModal,

  // Premium Products
  WelcomeBackModal,
  AddedProductModal,
  NeedCardUpdateModal,
  NeedPaymentDataModal,
  NeedSubscriptionModal,

  // Pick Page
  PickProductsModal,

  // Add To Queue
  ProductAddedToQueueModal,
  OfferModal,

  SkincareProductDetailsModal,
  FlashSaleModal,

  // Humble ------------------------------------------------------------------ /

  HumbleServerErrorModal,
  FlashSaleExpiredModal,
  FeedbackSuccessModal,
}
